// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__tvxTi","btn_primary":"styles_btn_primary__GJUQN","btn_outlined":"styles_btn_outlined__yWMQq"};